import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { RippleModule } from 'primeng/ripple';
import { MenteeRelation } from 'src/app/shared/types/mentee-relations.types';

@Component({
    selector: 'fp-match-modal',
    imports: [CommonModule, TranslateModule, AvatarModule, ButtonModule, DialogModule, RippleModule],
    templateUrl: './new-matching-alert.component.html',
    styleUrls: ['./new-matching-alert.component.scss']
})
export class MatchModalComponent implements OnInit {
  @Input() visible: boolean = false;
  @Input() matchedRelation: MenteeRelation | null = null;
  @Input() userRole: string = '';
  @Input() currentIndex: number = 0; // 0-based
  @Input() total: number = 0;
  @Output() closed = new EventEmitter<void>();
  @Output() ctaClicked = new EventEmitter<void>();
  @Output() nextClicked = new EventEmitter<void>();

  ngOnInit(): void {
    this.distinguishCoachee();
  }

  private distinguishCoachee() {
    if (this.userRole === 'ME' && this.matchedRelation?.supporter.type === 'coach') {
      this.userRole = 'CE';
    }
    return this.userRole;
  }

  get matchedUser() {
    return this.userRole === 'ME' || this.userRole === 'CE' ? this.matchedRelation?.supporter : this.matchedRelation?.mentee;
  }

  get currentUser() {
    return this.userRole === 'ME' || this.userRole === 'CE' ? this.matchedRelation?.mentee : this.matchedRelation?.supporter;
  }

  get ctaKey(): string {
    return this.userRole === 'CH' || this.userRole === 'CE' ? 'DASHBOARD.MATCH_MODAL.CTA_COACH' : 'DASHBOARD.MATCH_MODAL.CTA';
  }

  getInitials(name: string): string {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  close(): void {
    this.closed.emit();
  }

  cta(): void {
    this.ctaClicked.emit();
  }

  next(): void {
    this.nextClicked.emit();
    this.distinguishCoachee();
  }
}
